import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 relative overflow-hidden bg-gradient-to-b from-navy to-[#1e3a5f]" data-id="element-29">
      {/* Decorative elements */}
      <div className="absolute inset-0 dot-pattern opacity-50" data-id="element-30" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-32">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6 tracking-tight" data-id="element-33">
            ¿Listo Para Convertir Tus Prospectos en Citas Agendadas?
          </h2>

          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-34">
            Descubre si CONECKTA es para tu negocio en una llamada estratégica
            gratuita de 15 minutos.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-35">
            <button className="btn-cta text-lg px-10 py-5 w-full sm:w-auto group shadow-[0_0_30px_rgba(59,130,246,0.3)]" data-id="element-36">
              Agenda Tu Llamada Gratis
              <ArrowRightIcon className="w-6 h-6 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-37" />
            </button>

            <div className="flex items-center gap-2 text-sm text-gray-400 mt-2" data-id="element-38">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-39" />
              <span data-id="element-40">Sin compromiso · Sin tarjeta de crédito</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}